// Firebase core
import { initializeApp } from "firebase/app";

// Auth and Firestore
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Optional: analytics (only works in production)
import { getAnalytics } from "firebase/analytics";

// Your Firebase project config (from your console)
const firebaseConfig = {
  apiKey: "AIzaSyDq5hdHKKT-62VlIkcnoAoUOEU_K5Nnpz0",
  authDomain: "campuscrow-834be.firebaseapp.com",
  projectId: "campuscrow-834be",
  storageBucket: "campuscrow-834be.firebasestorage.app",
  messagingSenderId: "829716330998",
  appId: "1:829716330998:web:592c122b754e7ca7adafd7",
  measurementId: "G-YV8TF752B7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Optional: Only use analytics in production
if (process.env.NODE_ENV === "production") {
  getAnalytics(app);
}

// Export auth and db for use in the app
export const auth = getAuth(app);
export const db = getFirestore(app);
